import React from "react";

export default function ShareOptions({ url, eleRef }) {
    return (
        <div className="sharing-options">
            <ul>
                <li className="facebook-share left" onClick={() => eleRef.shareUrl('facebook', url)}>
                    <div className="M16_61 social-share">
                        <img src={require('../../assets/images/facebook.png')} className="facebookimg" alt="" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => eleRef.shareUrl('twitter', url)}>
                    <div className="M16_61 social-share">
                        <img src={require('../../assets/images/twitter.png')} className="twitterimg" alt="" />
                    </div>
                </li>
                <li className="pintrest-share left" onClick={() => eleRef.shareUrl('pintrest', url)}>
                    <div className="M16_61 social-share">
                        <img src={require('../../assets/images/pintrest.png')} className="pintrestimg" alt="" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => eleRef.shareUrl('whatsapp', url)}>
                    <div className="M16_61 social-share">
                        <img src={require('../../assets/images/whatsapp.png')} className="whatsappimg" alt="" />
                    </div>
                </li>
            </ul>
        </div>
    );
}


// WEBPACK FOOTER //
// src/shared/tools/fetal-movement-tracker/ShareOptions.js